import * as utils from './listenForElement';

/**
 * Listens for an element with id to be added to the page and sets a ref
 *
 * @param {object} methods - Methods
 * @param {function} methods.onElementFound When the element is found this callback will be disptached
 * @param {object} data - Arguments
 * @param {string} data.querySelector querySelector
 * @param {boolean} data.disconnect Will disconnet the observer after found
 * @param {HTMLElement} data.container container to use
 */
export const listenForElement = ( methods, data ) => {
  const { onElementFound } = methods || {};
  const { querySelector, disconnect = true, container } = data || {};
  const searchArea = container || ( document && document.body );

  if(
    typeof querySelector !== 'string' || querySelector === '' ||
    !( searchArea instanceof HTMLElement ) ||
    typeof onElementFound !== 'function'
  ){
    return;
  }

  const el = searchArea.querySelector( querySelector );
  if( el ){
    onElementFound( el );
    return;
  }

  const observer = new MutationObserver( ( mutations ) => {
    const nodeHandler = utils.composeNodeHandler( { disconnect, querySelector, observer }, { onElementFound } );

    mutations.forEach( ( { addedNodes } ) => {
      addedNodes.forEach( nodeHandler );
    } );
  } );

  observer.observe( searchArea, { subtree: true, childList: true } );

  return observer;
};

/**
 * Handles searching per node found by the observer
 * @param {object} data - Arguments
 * @param {object} methods - Methods
 */
export const composeNodeHandler = ( data, methods ) => ( node ) => {
  const { querySelector, disconnect, observer } = data || {};
  const { onElementFound } = methods || {};

  if( !onElementFound || !observer ){
    return;
  }

  const el = node?.parentElement?.querySelector( querySelector );

  if( !el ){
    return;
  }

  onElementFound( el );

  disconnect && observer.disconnect();
};